// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","steelColor":"#9a9a9a","midnightColor":"#201C1C","button":"GoogleButton_button__H1gfq","text":"GoogleButton_text__24y-Q"};